
<template>
  <div>
    <v-select
      dense
      outlined
      :clearable="true"
      :error-messages="erroMessage"
      :loading="isLoading"
      :items="items"
      :item-text="labelProvider"
      :item-value="itemValue"
      :label="label"
      @change="onChange"
      :disabled="disabled || isLoading"
    >
    <template v-slot:item="{active, item, attrs, on}">
        <v-list-item v-on="on" v-bind="attrs" #default="{active}" :class="highlightClass(item)">
          <v-list-item-content>
            <v-list-item-title>
              <v-row no-gutters align="center">
                <span>{{ labelProvider(item) }}</span>
              </v-row>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  /**
   * Este componente cria um Select que obtem seus itens através de um
   * serviço Rest
   */

  props: {
    //label a exibido
    label: {type: String, requirement: true},

    //função que que prove os items do select, deve ser uma Prommisse e
    //dev ser passada n formato service="(param) => service.method(param)"
    service: {type: Function, requirement: true},

    //Parametros a serem passados para o service
    serviceParams: {type: [Object, String, Number, Array], requirement: true},

    //nome da propriedade que é o identificados
    itemValue: {type: String, requirement: true},

    //função qye recebe o item e retorna a String que o representa
    labelProvider: {type: Function, requirement: true},

    disabled: {type: Boolean, default: false},

    //Lista de identificadores que devem ser destacados
    highlights: [Array],

  },

  data() {
    return {
      items: [],
      isLoading: false,
      erroMessage: null,
    };
  },

  watch: {
    serviceParams: function (a, b) {
      this.loadData();
    },
    disabled: function (a, b) {
      this.loadData();
    },
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      if (this.disabled) return;
      this.isLoading=true;
      this.service(this.serviceParams)
        .then((resp) => {
          this.items = resp.data;
          this.isLoading = false;
        })
        .catch((error) => {
          this.erroMessage = `Server Error: ${error.response.statusText}`;
          this.isLoading = false;
        });
    },
    onChange(value) {
      this.$emit('select', value);
    },
    highlightClass(item) {
      if (this.highlights) {
        if (this.highlights.find((i) => i == item[this.itemValue])) return 'highlight';
      }
      return '';
    },
  },
};
</script>

<style scoped>
.highlight {
  background-color: var(--v-blue-base);
}
</style>